import React from 'react';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    styled,
    Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const StyledTitle = styled(Typography)(() => ({
    fontWeight: 'bold',
    textTransform: 'uppercase',
    fontSize: '14px',
}));

const StyledAccordion = styled(Accordion)(() => ({
    boxShadow: 'none',
    '.MuiAccordionSummary-root': {
        borderBottom: '1px solid black',
        padding: 0,
    },
    '.MuiCollapse-root': {
        maxHeight: '200px',
        overflowY: 'auto',
        overflowX: 'hidden',
    },
}));

export const FilterAccordion: React.FC<{
    title: string;
    children: React.ReactNode;
}> = (props) => {
    const [expanded, setExpanded] = React.useState<boolean>(true);

    const handleAccordionChange =
        (panel: string) =>
        (event: React.SyntheticEvent, isExpanded: boolean) => {
            setExpanded(isExpanded);
        };

    return (
        <StyledAccordion
            expanded={expanded}
            onChange={handleAccordionChange('panel1')}
        >
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1bh-header"
            >
                <StyledTitle>{props.title}</StyledTitle>
            </AccordionSummary>
            <AccordionDetails>{props.children}</AccordionDetails>
        </StyledAccordion>
    );
};
